<template>
    <div>
      <!--列表  show-summary-->
      <div class="user-search"></div>
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" prop="name" label="用户名" >
        </el-table-column>
        <el-table-column align="center" prop="win" label="赢" >
        </el-table-column>
        
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { XyTop } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        formInline: {
          from: 1,
          limit: 10,
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        XyTop(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.from
              // this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.pageSize = parm.pageSize
        this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/data/Lucky.vue